import React, { useState } from "react";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import { Link, useNavigate } from "react-router-dom";
import SearchBar from "material-ui-search-bar";
import Alert from "@material-ui/lab/Alert";
import { CSVLink } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";

function caclculatePercentageForSort(poolObject, other) {
  let newObject = { 1: 0, inventoryStatus: 0 };
  if (poolObject.totalCount === null || poolObject.totalCount == 0) {
    if (other != null) {
      newObject["1"] = other;
      newObject["inventoryStatus"] = 0;
    } else {
      newObject["1"] = other;
      newObject["inventoryStatus"] = 0;
    }
    return newObject;
  } else {
    var countAvailable = poolObject.remainingInventory;
    var countTotal = poolObject.totalCount;
    if (other != null) {
      newObject["1"] = other;
      newObject["inventoryStatus"] = countAvailable / countTotal;
    } else {
      newObject["1"] = other;
      newObject["inventoryStatus"] = countAvailable / countTotal;
    }
    return newObject;
  }
}

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order == "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, domain) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    if (domain === "inventoryStatus") {
      const order = comparator(
        caclculatePercentageForSort(a[0], a[1]),
        caclculatePercentageForSort(b[0], b[1])
      );
      if (order !== 0) return order;
      return a["1"] - b["1"];
    } else {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    }
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "siteId", label: "Site" },
  { id: "dnsSiteCode", label: "DNS" },
  { id: "ownerTechnology", label: "Owner Technology" },
  { id: "inventoryStatus", label: "Inventory Status" },
  { id: "remainingInventory", label: "Remaining Inventory" },
];

const PoolsTableHead = (props) => {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    setSearched,
    setPage,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            paddingBottom="50px"
            style={{ fontSize: "1vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <div
              class="input-group"
              style={{ margin: "auto", marginBottom: "8px" }}
            >
              {headCell.id == "name" && (
                <SearchBar
                  placeholder="Name"
                  value={
                    searchedObj.domain === "name" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "name")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id == "description" && (
                <SearchBar
                  placeholder="Description"
                  value={
                    searchedObj.domain === "description"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) =>
                    handleInput(searchVal, "description")
                  }
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id == "siteId" && (
                <SearchBar
                  placeholder="Site"
                  value={
                    searchedObj.domain === "siteId" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "siteId")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id != "ownerTechnology" && (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {(headCell.id == "dnsSiteCode" ||
                    headCell.id == "inventoryStatus" ||
                    headCell.id == "remainingInventory") && (
                    <div align="center" style={{ fontSize: ".9vw" }}>
                      {headCell.label}
                    </div>
                  )}
                  {orderBy === headCell.name ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </div>
            {headCell.id == "ownerTechnology" && (
              <select
                class="form-control"
                name="ownerTechnology"
                style={{
                  width: "125px",
                  fontSize: ".75vw",
                  marginBottom: "12px",
                }}
                onChange={(searchVal) =>
                  handleInput(
                    searchVal.target.value.toString(),
                    "ownerTechnology"
                  )
                }
              >
                <option value="">Technology</option>
                <option value="IPT">IPT</option>
                <option value="TEAMS">TEAMS</option>
              </select>
            )}
          </TableCell>
        ))}
        <TableCell
          align="center"
          style={{ fontSize: ".9vw", marginBottom: "20px" }}
        >
          Ranges
        </TableCell>
        <TableCell
          align="center"
          style={{ fontSize: ".9vw", marginBottom: "20px" }}
        >
          Edit
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
}));

const PoolsTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { tableTitle } = props;

  return (
    <Toolbar className={classes.root}>
      <Typography
        className={classes.title}
        variant="h5"
        id="tableTitle"
        component="div"
      >
        {tableTitle}
      </Typography>
    </Toolbar>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  card: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    fontFamily: "Nunito",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  smallColumn: {
    width: "10px",
  },
  searchbar: {
    width: "200px",
    height: "40px",
  },
}));

const rangeHeaders = [
  { label: "Name", key: "poolName" },
  { label: "Description", key: "poolDescription" },
  { label: "Primary Site", key: "siteName" },
  { label: "Primary Site Id", key: "siteId" },
  { label: "Associated Secondary Sites", key: "secondarySites" },
  { label: "Range Id", key: "rangeId" },
  { label: "Starting Number", key: "rangeStartNumber" },
  { label: "Ending Number", key: "rangeEndNumber" },
  { label: "Total Count", key: "rangeTotalCount" },
  { label: "Available Count", key: "rangeAvailableCount" },
  { label: "Status", key: "rangeOnboardingStatus" },
];

const LowInventoryPoolsTable = ({ data, title, isAdmin }) => {
  const history = useNavigate();
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [rows, setRows] = useState(data);
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

  const handleFilter = () => {
    const filteredRows = rows.filter((row) => {
      if (searchedObj.domain === "siteId") {
        var idList = row.siteId
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
        var nameList = row.siteName
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
        return idList + nameList;
      }
      if (searchedObj.domain === "name") {
        return row.name
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "description" && row.description != null) {
        return row.description
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "ownerTechnology") {
        return row.ownerTechnology
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "dnsSiteCode") {
        return row.site.dnsSiteCode
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "inventoryStatus") {
        return row.range.inventoryStatus
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "remainingInventory") {
        return row.range.remainingInventory
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, handleFilter().length - page * rowsPerPage);

  const getColor = (inventoryStatus) => {
    if (inventoryStatus <= 10) return "red";
    if (inventoryStatus >= 11 && inventoryStatus <= 20) return "orange";
    return "green";
  };

  const getData = (pool) => {
    var total = pool.totalCount;
    var available = pool.remainingInventory;
    var inventoryStatus = 0;
    if (available > 0 && total > 0) {
      inventoryStatus = Math.round((available / total) * 100);
    }
    var remainingInventory = `${available} / ${total}`;
    var returnedColor = getColor(inventoryStatus);

    return (
      <>
        <TableCell
          style={{ backgroundColor: returnedColor, color: "white" }}
          align="center"
        >
          {inventoryStatus}%
        </TableCell>
        <TableCell
          style={{ backgroundColor: returnedColor, color: "white" }}
          align="center"
        >
          {remainingInventory}
        </TableCell>
      </>
    );
  };

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.card}>
          <PoolsTableToolbar tableTitle={title} />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <PoolsTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                searchedObj={searchedObj}
                setSearched={setSearched}
                setPage={setPage}
              />
              <TableBody>
                {stableSort(
                  handleFilter(),
                  getComparator(order, orderBy),
                  orderBy
                )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{
                          height: "80px",
                          background: index % 2 ? "#f8f8f8" : "white",
                        }}
                      >
                        <TableCell align="center">
                          {row.ranges.length > 0 && (
                            <CSVLink
                              data={row.ranges.map((r) => {
                                return Object.assign({
                                  rangeId: r.id,
                                  rangeStartNumber: `=""${r.startNumber}""`,
                                  rangeEndNumber: `=""${r.endNumber}""`,
                                  rangeTotalCount: r.totalCount,
                                  rangeAvailableCount: r.availableCount,
                                  rangeOnboardingStatus: r.description,
                                  poolName: row.name,
                                  poolDescription: row.description,
                                  siteName: row.siteName,
                                  siteId: row.siteId,
                                  secondarySites: [
                                    row.secondarySites.map((s) => {
                                      return s.name;
                                    }),
                                  ],
                                  poolId: row.id,
                                });
                              })}
                              headers={rangeHeaders}
                              filename={`DMV_${row.name}_Ranges.csv`}
                            >
                              <GetAppIcon />
                            </CSVLink>
                          )}
                        </TableCell>
                        <TableCell align="left" style={{ width: "350px" }}>
                          {row.name}
                        </TableCell>
                        <TableCell align="left" style={{ width: "350px" }}>
                          {row.description}
                        </TableCell>
                        <TableCell align="left" style={{ width: "350px" }}>
                          {row.siteId} - {row.siteName}
                        </TableCell>
                        <TableCell align="center">{row.dnsSiteCode}</TableCell>
                        <TableCell align="center">
                          {row.ownerTechnology}
                        </TableCell>
                        {getData(row)}
                        <TableCell className={classes.smallColumn}>
                          <Link
                            to={`/ranges/byPool/${row.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <Button variant="contained" size="small">
                              <VisibilityIcon />
                            </Button>
                          </Link>
                        </TableCell>
                        <TableCell className={classes.smallColumn}>
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={() => history(`/pools/edit/${row.id}`)}
                            disabled={!isAdmin}
                          >
                            <EditIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && handleFilter().length >= rowsPerPage && (
                  <TableRow style={{ height: 80 * emptyRows }}>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[20, 35, 50]}
            component="div"
            count={handleFilter().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Card>
      </div>
    </>
  );
};

export default LowInventoryPoolsTable;
